import Divider from "@mui/material/Divider";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Divider key={component.id} />;
}

export default Component;
